import React, { useState } from 'react'
import MySelect from '../../../UI/form/MySelect'
import MyButton from '../../../UI/form/MyButton'
import { addValueObjInArrayWithIdForm } from '../../../../helpers/form/FormHelper'
import { useSelector } from 'react-redux'

const WorkLinePlaceGroupUserForm = ({ users, usersWork, setUsersWork }) => {

    const userStore = useSelector(state => state.user.user)
    const [userId, setUserId] = useState('')

    const addUserToArr = () => {
        if (userId) {
            let user = null

            for (const userOne of users) {
                if (userOne.id == userId) {
                    user = userOne
                }
            }

            if (user) {
                // addValueObjInArrayWithIdForm(setUsersWork, user)
                setUsersWork(prev => [...prev, user])
                setUserId('')
            }
        }
    }

    const isUserInWork = (userId) => {
        let isUser = false

        for (const userOne of usersWork) {
            if (userOne.id == userId) {
                isUser = true
            }
        }

        return isUser
    }

  return (
    <div className='workLinePlaceGroup__form'>
        <p 
            className='workLinePlaceGroup__formDescHeader'
        >
            Оберіть людину зі списку, яка буде працювати з Вами в команді
        </p>
        <div>
            <div>            
                <MySelect
                    value={userId}
                    label="Користувач"
                    labelId="select__unitMeasure-label"
                    id='select__unitMeasure'
                    onChange = {e => {
                        // setValueForm(e)
                        setUserId(e)
                        // setEvent({...event, categoryId: e})
                    }}
                    nameField='Од. виміру'
                    // sx={{width: '200px'}}
                    options={
                        users && users.length > 0 ? 
                            users.map(userOne => {
                                if (
                                    (userOne.id && !isUserInWork(userOne.id)) && // Прибираємо вже наявного в групі
                                    (userOne.id !== userStore.id) // Прибираємо самого себе (людину, що обирає)
                                ) {
                                    return {
                                        id: userOne.id, 
                                        name: userOne.surname + ' ' + userOne.name
                                    }
                                }
                            })
                        : []	
                    }
                    // options={[]}
                />
            </div>
            <MyButton
                size='sm'
                onClick={addUserToArr}
                disabled={!userId ? true : false}
            >
                Додати
            </MyButton>
        </div>
    </div>
  )
}

export default WorkLinePlaceGroupUserForm